import { createContext, useContext } from 'react';

export interface FormContatoContextType {
  data: FormContatoDataType;
  params: FormContatoParamsType;
}

const FormContatoContext = createContext<FormContatoContextType>({} as FormContatoContextType);

export const useFormContatoContext = () => {
  return useContext(FormContatoContext);
};

export default FormContatoContext;
